import { create } from "zustand";
import { persist } from "zustand/middleware";

interface User {
  id: number;
  email: string;
  firstName?: string;
  lastName?: string;
}

interface AuthState {
  user: User | null;
  isAuthenticated: boolean;
  isProfileComplete: boolean;

  // Actions
  setAuth: (user: User, isProfileComplete?: boolean) => void;
  clearAuth: () => void;
  updateUser: (user: Partial<User>) => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      isAuthenticated: false,
      isProfileComplete: false,

      setAuth: (user, isProfileComplete = false) => {
        set({
          user,
          isAuthenticated: true,
          isProfileComplete,
        });
      },

      clearAuth: () => {
        set({
          user: null,
          isAuthenticated: false,
          isProfileComplete: false,
        });
      },

      updateUser: (userData) =>
        set((state) => ({
          user: state.user ? { ...state.user, ...userData } : null,
        })),
    }),
    {
      name: "auth-storage", // localStorage key
      partialize: (state) => ({
        user: state.user,
        isAuthenticated: state.isAuthenticated,
        isProfileComplete: state.isProfileComplete,
      }),
    },
  ),
);
